

let counter=1
const sideDividerMenu  =()=> 
{
    let id='divider-'+counter++
    return {
        divider:true, id 
    }
}

const inviteMenu={
    id:'invite',
    name:'Invitation',
    path:'/invitations',

    // sub:[
    //     {  id:'invite_normal',name:'Invite Visitors', path:'/invitations/invite'},
    //     //{  id:'invite_group',name:'Invite Group Visitors', path:'/invite_group'},
    //     {  id:'invite-divide-1', divider:true},
    //     //{  id:'invite_query',name:'Inquiry Invitations', path:'/invite_query'},
    //     {  id:'invite_query',name:'Invitations', path:'/invitations'},

        
    //     //{  id:'invite-divide-1', divider:true},
    //     //{  id:'invite-profile-request',name:'Inquiry Profile Request', path: '/invite_query'},
    // ]
}

const visitorMenu={
    id:'visitors',
    name:'Visitors',
    path:'/visitor',
    // sub:[
    //     {  id:'visitors-create',name:'Caeate Visitor', path:'/visitor/create'},
    //     {  id:'visitors-divide-1', divider:true},
    //     {  id:'visitors-inquiry',name:'Inquiry Visitors', path:'/visitor'},
    //     //{  id:'visitors-history',name:'Visitor Entry Histories',},
    //     //{  id:'visitors-divide-1', divider:true},
    //     //{  id:'courier-inquiry',name:'Inquiry Couriers',},
    //     //{  id:'courier-histories',name:'Courier Entry Histories',},
    // ]
}

const requestMenu={
    id:'request',
    name:'Walk-in Requests',
    path:'/request',
}

const passMenu={
    id:'pass',
    name:'Access Management',
    path:'/pass',
    // sub:[
    //     {  id:'visitors-create',name:'Caeate Visitor', path:'/visitor/create'},
    //     {  id:'visitors-divide-1', divider:true},
    //     {  id:'visitors-inquiry',name:'Inquiry Visitors', path:'/visitor'},
    //     //{  id:'visitors-history',name:'Visitor Entry Histories',},
    //     //{  id:'visitors-divide-1', divider:true},
    //     //{  id:'courier-inquiry',name:'Inquiry Couriers',},
    //     //{  id:'courier-histories',name:'Courier Entry Histories',},
    // ]
}


// const visitorMenu={
//     id:'visitors',
//     name:'Visitor',
//     sub:[
//         {  id:'visitors-create',name:'Caeate Visitor', path:'/visitor/create'},
//         {  id:'visitors-divide-1', divider:true},
//         {  id:'visitors-inquiry',name:'Inquiry Visitors', path:'/visitor'},
//         //{  id:'visitors-history',name:'Visitor Entry Histories',},
//         //{  id:'visitors-divide-1', divider:true},
//         //{  id:'courier-inquiry',name:'Inquiry Couriers',},
//         //{  id:'courier-histories',name:'Courier Entry Histories',},
//     ]
// }


const entryLogMenu={
    id:'inquiry-log',
    name:'Transaction Log',
    large:true,
    sub:[
        {  id:'inquiry-visitor',name:'Visitor Transaction Log', path:'/access/visitors'},
        // {  id:'inquiry-couriers',name:'Courier Transaction Log', path:'/access/couriers'},
        {  id:'inquiry-divide-1', divider:true},
        {  id:'inquiry-auditlog',name:'AuditLog', path:'/access/auditlog'},

        ]
}
const entryLogMenuAdmin={
    id:'inquiry-admin-log',
    name:'Transaction Log',
    large:true,
    sub:[
        {  id:'inquiry-admin-visitor',name:'Visitor Entry Log', path:'/access/visitors'},
//        {  id:'inquiry-admin-couriers',name:'Courier Entry Log', path:'/access/couriers'},
        {  id:'inquiry-admin-divide-1', divider:true},
//        {  id:'inquiry-admin-visitors',name:'Visitor Inquiries', path:'/access/visitor_inquiry'},
//        {  id:'inquiry-admin-divide-1', divider:true},
        {  id:'inquiry-auditlog',name:'AuditLog', path:'/access/auditlog'},

        ]
}


const adminVisitorMenu={
    id:'admin_visitors',
    name:'Visitor Enquiry',
    large: true,
    path:'/access/visitor_inquiry',
    // sub:[
    //     {  id:'admin-reason',name:'Reason for Visit', path:'/admin/reason'},
    //     {  id:'admin-user',name:'Create User', path:'/admin/user'},
    //     {  id:'admin-divide-1', divider:true},
    //     {  id:'admin-blacklist',name:'Blacklist', path:'/admin/blacklist'},
    // ]
}


const adminMenu={
    id:'admin',
    name:'Administration',
    large: true,
    
    sub:[
        {  id:'admin_visitors',name:'Visitor Records', path:'/access/visitor_inquiry'},
        {  id:'admin-reason',name:'Purpose of Visit', path:'/admin/reason'},
        {  id:'admin-viphost',name:'VIP Hosts', path:'/admin/viphost'},
        {  id:'admin-about',name:'About', path:'/admin/about'},
        //{  id:'admin-divide-1', divider:true},
        //{  id:'admin-user',name:'Users', path:'/admin/user'},
        //
        //{  id:'admin-blacklist',name:'Blacklist', path:'/admin/blacklist'},
    ]
}

const reportMenu={
    id:'report',
    name:'Report',
    large: true,
    sub:[
        {  id:'report-report1',name:'Report 1', path:'/reports/report1'},
        {  id:'report-report2',name:'Report 2', path:'/reports/report2'},
        {  id:'report-report3',name:'Report 3', path:'/reports/report3'},
        {  id:'report-divide-1', divider:true},
        {  id:'report-report11',name:'Report 11', path:'/reports/report11'},
    ]
}


const MENUS = {

    ADMIN:  [

    ]

}

const configureMemu=(roles, floors)=>{
    
	const hasfloor = floors && floors.length>0
	
    let menu=[]
    
    if (roles)
    {
        let rs = new Set(roles.map(x=>x.trim().toUpperCase()))
        
        if (rs.has('HOST') && hasfloor)
        {
            menu.push(inviteMenu)
            menu.push(sideDividerMenu())
            menu.push(visitorMenu)
            // menu.push(sideDividerMenu())
            // menu.push(passMenu)
            
            menu.push(sideDividerMenu())
            
            menu.push(entryLogMenu)
            menu.push(requestMenu)
            
        }
        else if (rs.has('ADMIN'))
        {
            menu.push(entryLogMenuAdmin)
        }

        if (rs.has('ADMIN'))
        {
           // menu.push(adminVisitorMenu)
            menu.push(adminMenu)
        
        }

        //menu.push(reportMenu)
        
    
    }

    return menu

}

export default configureMemu